import type { Driver } from '../types';

export class MemoryDriver implements Driver {
  map: Map<string, string>;

  constructor() {
    this.map = new Map<string, string>();
  }

  setItem(key: string, value: string) {
    this.map.set(key, JSON.stringify(value));
  }

  getItem(key: string) {
    return this.map.get(key);
  }

  removeItem(key: string) {
    this.map.delete(key);
  }
}
